import { showMessages } from '@intercom/messenger-js-sdk';
import { buttonV2Class } from '@synoptic/ui-kit/button-v2/button-v2.css.js';
import { ButtonV2 } from '@synoptic/ui-kit/button-v2/button-v2.js';
import { ChatBubbleEmptyIcon } from '@synoptic/ui-kit/icons/react/chat-bubble-empty.js';
import { MailIcon } from '@synoptic/ui-kit/icons/react/mail.js';
import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { Link } from '@/routes-utils/navigation.tsx';
import { NavButtonItemV2, NavButtonItemV2Props } from './nav-item-v2.tsx';
import {
  requestAccessAction,
  requestAccessActions,
  requestAccessBody,
  requestAccessDescription,
} from './request-access-nav-item-v2.css.ts';

type RequestAccessNavItemV2Props = Pick<
  NavButtonItemV2Props,
  'icon' | 'label' | 'badge'
> & {
  description: string;
  actions?: ReactNode;
};

const ContactActions = () => (
  <>
    <ButtonV2
      variant="primary"
      startIcon={<ChatBubbleEmptyIcon />}
      className={requestAccessAction}
      onClick={() => showMessages()}
    >
      Open Support Chat
    </ButtonV2>
    <Link
      to="mailto:info@synoptic.com"
      className={clsx(buttonV2Class.secondary, requestAccessAction)}
    >
      <MailIcon />
      Email us
    </Link>
  </>
);

export const RequestAccessNavItemV2 = ({
  icon,
  label,
  badge,
  description,
  actions,
}: RequestAccessNavItemV2Props) => (
  <ModalRoot>
    <ModalTrigger asChild>
      <NavButtonItemV2
        icon={icon}
        label={label}
        badge={badge}
        closeMenuOnSelect={false}
      />
    </ModalTrigger>
    <ModalContent>
      <ModalHeader>
        <ModalTitle>{label}</ModalTitle>
      </ModalHeader>
      <div className={requestAccessBody}>
        <p className={requestAccessDescription}>{description}</p>
        <div className={requestAccessActions}>
          {actions ?? <ContactActions />}
        </div>
      </div>
    </ModalContent>
  </ModalRoot>
);
